import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DetailItem } from '../se-side-details-models';

@Component({
  selector: 'se-side-details-item',
  templateUrl: './se-side-details-item.component.html',
  styleUrls: ['./se-side-details-item.component.scss']
})
export class SeSideDetailsItemComponent implements OnInit, OnChanges {

    @Input() details: DetailItem[] = [];
    @Input() title ?: string = 'SecondaryColumns';

    constructor() {
        console.log('>>>>>>>> SeSideDetailsItemComponent - Details: ', this.details);
    }

    ngOnInit() {
        console.log('>>>>>>>> SeSideDetailsItemComponent - Details: ', this.details);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['details']) {
            console.log('cambiateo: ', changes['details']);
        }
        // DGS_AP: recuperare i valori che vanno visualizzati in base alle colonne presenti nel dettaglio
        // se Items è maggiore di 1 non deve far nulla e mostRARE UN MESSAGGIO

    }


    _isTooltipDisabled (element) {
        return element.offsetWidth >= element.scrollWidth;
    }
}
